import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renderiza os cards de estatísticas da aba de Frequência.
 * Usa um layout flex responsivo.
 */
const AttendanceStatsCards = ({ 
    periodStats, 
    weeklyAverageStr, 
    consecutiveAbsences, 
    isHighRisk, 
    riskLevel 
}) => {
    return (
        <div className="d-flex flex-wrap gap-3 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {/* Presenças no período */}
            <div 
                className="p-3 d-flex align-items-center flex-grow-1 border shadow-sm" 
                style={{ 
                    minWidth: '180px', 
                    borderRadius: '12px',
                    backgroundColor: '#f0fdf4',
                    borderColor: 'rgba(74, 161, 88, 0.15)'
                }}
            >
                <i className="mdi mdi-check-circle-outline font-size-24 me-3" style={{ color: '#15803d' }}></i>
                <div>
                    <p className="mb-0 font-size-12 fw-bold" style={{ color: '#15803d' }}>Presenças no período</p>
                    <h5 className="mb-0 fw-900 font-size-20" style={{ color: '#15803d', marginTop: '2px' }}>{periodStats.attended}</h5>
                </div>
            </div>

            {/* Faltas no período */}
            <div 
                className="p-3 d-flex align-items-center flex-grow-1 border shadow-sm" 
                style={{ 
                    minWidth: '180px', 
                    borderRadius: '12px',
                    backgroundColor: '#fef2f2',
                    borderColor: 'rgba(240, 80, 80, 0.15)'
                }}
            >
                <i className="mdi mdi-close-circle-outline font-size-24 me-3" style={{ color: '#b91c1c' }}></i>
                <div>
                    <p className="mb-0 font-size-12 fw-bold" style={{ color: '#b91c1c' }}>Faltas no período</p>
                    <h5 className="mb-0 fw-900 font-size-20" style={{ color: '#b91c1c', marginTop: '2px' }}>{periodStats.absent}</h5>
                </div>
            </div>

            {/* Média Semanal (geral) */}
            <div 
                className="p-3 d-flex align-items-center flex-grow-1 border shadow-sm" 
                style={{ 
                    minWidth: '180px', 
                    borderRadius: '12px',
                    backgroundColor: '#fef8f3',
                    borderColor: 'rgba(72, 39, 18, 0.12)'
                }}
            >
                <i className="mdi mdi-chart-bar font-size-24 me-3" style={{ color: 'var(--color-brand-secondary)' }}></i>
                <div>
                    <p className="mb-0 font-size-12 fw-bold" style={{ color: 'var(--color-brand-secondary)' }}>Média semanal</p>
                    <h5 className="mb-0 fw-900 font-size-20" style={{ color: 'var(--color-brand-primary)', marginTop: '2px' }}>{weeklyAverageStr}</h5>
                </div>
            </div>

            {/* Risco de Abandono */}
            <div 
                className="p-3 d-flex align-items-center flex-grow-1 border shadow-sm" 
                style={{ 
                    minWidth: '180px', 
                    borderRadius: '12px',
                    backgroundColor: isHighRisk ? '#fef2f2' : '#fef8f3',
                    borderColor: isHighRisk ? 'rgba(240, 80, 80, 0.20)' : 'rgba(72, 39, 18, 0.12)'
                }}
            >
                <i 
                    className={`mdi mdi-account-remove-outline font-size-24 me-3`}
                    style={{ color: isHighRisk ? '#b91c1c' : 'var(--color-brand-secondary)' }}
                ></i>
                <div>
                    <p 
                        className={`mb-0 font-size-12 fw-bold`}
                        style={{ color: isHighRisk ? '#b91c1c' : 'var(--color-brand-secondary)' }}
                    >
                        Risco de abandono
                    </p>
                    <h5 
                        className={`mb-0 fw-900 font-size-20`}
                        style={{ color: isHighRisk ? '#b91c1c' : 'var(--color-brand-primary)', marginTop: '2px' }}
                    >
                        {riskLevel}
                    </h5>
                </div>
            </div>
        </div>
    );
};

AttendanceStatsCards.propTypes = {
    periodStats: PropTypes.shape({
        attended: PropTypes.number,
        absent: PropTypes.number
    }).isRequired,
    weeklyAverageStr: PropTypes.string.isRequired,
    consecutiveAbsences: PropTypes.number.isRequired,
    isHighRisk: PropTypes.bool.isRequired,
    riskLevel: PropTypes.string.isRequired
};

export default AttendanceStatsCards;
